import { ChannelTypeInternal, TariffKindInternal } from '../../../../../data-access/gql-types/graphql';
import { TariffItem } from '../../../types/tariffs';
import { tariffKind } from '../../channel-details/optimizer/configuration/utils/tariff-kind';

export const configurationExists = [
  ChannelTypeInternal.Switch,
  ChannelTypeInternal.Blind,
  ChannelTypeInternal.Gate,
  ChannelTypeInternal.Light,
  ChannelTypeInternal.Meter,
  ChannelTypeInternal.BinarySensor,
];

export const getTariffDataByEnum = (allTariffs: TariffItem[], kind: TariffKindInternal) => {
  const data = tariffKind[kind];

  const operatorTariffs =
    allTariffs.find((x) => x.operator.toLowerCase() === data.operator.toLowerCase())?.tariffs || [];
  const foundTariff = operatorTariffs.find((x) => x.name.toLowerCase() === data.tariff.toLowerCase());

  return foundTariff || null;
};
